import View from "./View";
import icons from "url:../../img/icons.svg";

class addRecipeView extends View {
  _parentElement = document.querySelector(".upload");
  _window = document.querySelector(".add-recipe-window");
  _overlay = document.querySelector(".overlay");
  _btnOpen = document.querySelector(".nav__btn--add-recipe");
  _btnClose = document.querySelector(".btn--close-modal");
  _btnUpload = document.querySelector(".upload__btn");
  _message = "Receipe was successfully uploaded";

  constructor() {
    super();

    this._addHandlerShowWindow();
  }

  toggleWindow() {
    this._overlay.classList.toggle("hidden");
    this._window.classList.toggle("hidden");
  }

  _addHandlerShowWindow() {
    this._overlay.addEventListener("click", this.toggleWindow.bind(this));
    this._btnOpen.addEventListener("click", this.toggleWindow.bind(this));
    this._btnClose.addEventListener("click", this.toggleWindow.bind(this));
  }

  _generateMarkup() {}

  addHandlerUpload(handler) {
    this._parentElement.addEventListener("submit", function (e) {
      e.preventDefault();
      const dataArray = [...new FormData(this)]; // this === _parentElement
      const dataObject = Object.fromEntries(dataArray);
      console.log("formData", dataArray);
      handler(dataObject);
    });
  }
}

export default new addRecipeView();

// state = {
//   recipe: {},
//   search: {
//     query: "",
//     results: [],
//     page: 1,
//     resultsPerPage: RESULTS_PER_PAGE,
//   },
// };
